import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import "../Notas/MisNotas.css"

import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import IconButton from '@material-ui/core/IconButton';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { getCATNotas } from "../../../app/models/CATNotas";
import { green } from '@material-ui/core/colors';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

export default observer(function CATNotas() {
    
    const {userStore: {user}} = useStore();
    const nf = new Intl.NumberFormat("en-IN");
    const {CATCursosStore, modalStore} = useStore();
    const {getCATNotasAlumno, createDiplomaAlumno} = CATCursosStore;
    var id: string | undefined = user?.id

    useEffect(() => {
        if (id) {
            getCATNotasAlumno()
        }
    }, [id, getCATNotasAlumno]);

    if (CATCursosStore.loadingInitial) return <LoadingComponent content='Cargando datos..' />
  
    return (
        <>
            <h1 className="notas-title">Mis Notas</h1>
            <div className="intro2">Estimado participante, el Instituto Nacional de Administración Publica -INAP, pone a tu disposición el Portal de Emisión de Diplomas y Certificaciones, como una herramienta de autogestión para la observación de tus certificados de servicios academicos aprobados.</div>
            <div className="table-responsive">
                <table>
                    <thead>
                        <tr className="nota-head-row">
                            <th  className="nota-body-td">Código</th>
                            <th  className="nota-body-td">Servicio Académico</th>
                            <th  className="nota-body-td">Aprobado</th>
                            <th  className="nota-body-td">Nota</th>
                            <th  className="nota-body-td">Generar Certificado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {CATCursosStore.getCATNotasByCodigo.map((item:getCATNotas) => {
                            if(parseFloat(item.nota) >= 69.50){
                                if(item.urlDoc !== null){
                                    return(
                                        <tr key={item.id} className="nota-body-row">
                                            <td  className="nota-body-td">
                                                {item.codigoEdicion}
                                            </td>
                                            <td  className="nota-body-td">{item.nombre}</td>
                                            <td  className="nota-body-td"><CheckCircleOutlineIcon style={{ color: green[400], fontSize: 40 }} /></td>
                                            <td  className="nota-body-td">{item.nota}</td>
                                            <td  className="nota-body-td"><NoteAddIcon color="disabled"/></td>
                                        </tr>
                                    )
                                }else{
                                    return(
                                        <tr key={item.id} className="nota-body-row">
                                            <td className="nota-body-td">
                                                {item.codigoEdicion}
                                            </td>
                                            <td  className="nota-body-td">{item.nombre}</td>
                                            <td  className="nota-body-td"><CheckCircleOutlineIcon style={{ color: green[400], fontSize: 40 }} /></td>
                                            <td  className="nota-body-td">{item.nota}</td>
                                            <td  className="nota-body-td">
                                                <IconButton id="botonGenerar" aria-label="delete" onClick={() => {
                                                    createDiplomaAlumno(item.edicionId)
                                                    }}>
                                                    <NoteAddIcon style={{color: "white"}} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    )
                                }
                            }else if(parseFloat(item.nota) < 69.50 && item.nota != "-"){
                                return(
                                    <tr key={item.id} className="nota-body-row">
                                        <td className="nota-body-td">
                                            {item.codigoEdicion}
                                        </td>
                                        <td  className="nota-body-td">{item.nombre}</td>
                                        <td  className="nota-body-td"><HighlightOffIcon color="secondary" style={{fontSize: 40}} /></td>
                                        <td  className="nota-body-td">{item.nota}</td>
                                        <td  className="nota-body-td">-</td>
                                    </tr>
                                )
                            }else if(item.nota == "-"){
                                return(
                                    <tr key={item.id} className="nota-body-row">
                                        <td className="nota-body-td">
                                            {item.codigoEdicion}
                                        </td>
                                        <td  className="nota-body-td">{item.nombre}</td>
                                        <td  className="nota-body-td">-</td>
                                        <td  className="nota-body-td">{item.nota}</td>
                                        <td  className="nota-body-td">-</td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
})